import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {AirbnbAuth, ExternalListingModelType} from '../../../../models/airbnbAuthModel';
import ListingsPicker from '../../../../components/ListingsPicker';
import Flex from '../../../../components/Flex';
import Text from '../../../../components/Text';
import {PillButton} from '../../../../components/Button';
import {Helmet} from 'react-helmet';

interface WithInjectedProps {
  airbnbAuth: AirbnbAuth;
}

interface State {
  selection: ExternalListingModelType[];
}

@inject('airbnbAuth')
@observer
export default class SelectListings extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {selection: []};
  }

  public componentDidMount() {
    this._withInjectedProps.airbnbAuth.loadExernalListings();
  }

  public render() {
    const {externalListings} = this._withInjectedProps.airbnbAuth;

    return (
      <React.Fragment>
        <Helmet>
          <title>Please choose the listings you want to import to Cohost AI.</title>
        </Helmet>

        <Text withComponent="h1">
          You have authenticated with Airbnb successfully. Now please choose the listings which you want us to help
          manage.
        </Text>

        <ListingsPicker
          listings={[...externalListings]}
          onSelectionChange={this._handleSelectionChange}
          selection={this.state.selection}
        />

        <Flex justify="flex-end">
          <PillButton variant="primary" onClick={this._handleSubmit}>
            Next
          </PillButton>
        </Flex>
      </React.Fragment>
    );
  }

  private _handleSelectionChange = (selection: ExternalListingModelType[]) => this.setState({selection});

  private _handleSubmit = () =>
    this._withInjectedProps.airbnbAuth.importExternalListings(
      this.state.selection.map(listing => listing.otaListingId)
    );

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConnectListings/ConnectAirbnb/SelectAirbnbListings/SelectAirbnbListings.tsx